import { createUseStyles } from 'react-jss';

export default createUseStyles<'container' | 'header'>({
  container: {
    width: '100%',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    '& h5': {
      margin: '0.5em 0 0 0',
    },
  },
});
